var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6 11.0521C3.20982 11.0521 0.947925 8.79018 0.947925 6C0.947925 3.20982 3.20982 0.947925 6 0.947925C8.79018 0.947925 11.0521 3.20982 11.0521 6C11.0521 8.79018 8.79018 11.0521 6 11.0521Z",
    stroke: "currentColor",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\xBC\x9F",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09432 2.87943C6.6515 2.87943 7.10582 3.02516 7.44871 3.33375C7.79159 3.63377 7.96303 4.04523 7.96303 4.56813C7.96303 4.99673 7.85159 5.34819 7.64586 5.62249C7.56872 5.70821 7.32013 5.93966 6.90867 6.29969C6.75437 6.42827 6.64293 6.57399 6.56578 6.72829C6.48006 6.89973 6.4372 7.07974 6.4372 7.28547V7.40548H5.45142V7.28547C5.45142 6.95973 5.50285 6.67686 5.62286 6.44541C5.73429 6.21397 6.0686 5.85394 6.62579 5.35676L6.72865 5.23675C6.88295 5.04816 6.9601 4.84244 6.9601 4.62813C6.9601 4.34526 6.87438 4.12238 6.72008 3.95951C6.55721 3.79664 6.32577 3.71949 6.03432 3.71949C5.65715 3.71949 5.39141 3.83093 5.22854 4.07095C5.08282 4.26811 5.01424 4.55098 5.01424 4.91101H4.03703C4.03703 4.27668 4.21704 3.7795 4.59421 3.41947C4.96281 3.05945 5.45999 2.87943 6.09432 2.87943ZM5.94001 7.82562C6.1286 7.82562 6.29146 7.88563 6.42005 8.00564C6.54005 8.12565 6.60863 8.27994 6.60863 8.46853C6.60863 8.65711 6.54005 8.81998 6.41147 8.93999C6.28289 9.06 6.1286 9.12001 5.94001 9.12001C5.75142 9.12001 5.59713 9.05143 5.46855 8.93142C5.33997 8.81141 5.27996 8.65711 5.27996 8.46853C5.27996 8.27994 5.33997 8.12565 5.46855 8.00564C5.59713 7.88563 5.75142 7.82562 5.94001 7.82562Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionGhost);
export default __webpack_public_path__ + "static/media/question-ghost.88a30f76136f121a291b7f5b4d6f7b21.svg";
export { ForwardRef as ReactComponent };